
let searchAllProductUrl = '/search?view=json_result&type=product&page=1&unavailable_products=hide&q=*';

/**
 * 复制元素
 *
 * @param copyIndex 被复制的元素索引值
 * @param id 新元素id
 * @param index 新元素索引值
 * @param copyClassName 被复制的元素类名
 * @returns {null|*|jQuery}
 */
function copyDivByClassName(copyIndex,id,index,copyClassName){

    if ($("."+copyClassName).eq(copyIndex) != null && $("."+copyClassName).eq(copyIndex).length <= 0){
        return null;
    }

    var node = $("."+copyClassName).eq(copyIndex).clone(true);
    node.attr('id',id);
    node.attr('data-index',index);
    return node;
}

/**
 * 复制元素
 *
 * @param copyIndex 被复制的元素索引值
 * @param id 新元素id
 * @param index 新元素索引值
 * @param copyClassName 被复制的元素类名
 * @param parentId 被复制的元素父级id
 * @returns {null|*|jQuery}
 */
function copyDivByParentId(copyIndex,id,index,copyClassName,parentId){

    if ($("#" + parentId + " ." + copyClassName).eq(copyIndex) != null && $("."+copyClassName).eq(copyIndex).length <= 0){
        return null;
    }

    var node = $("#" + parentId + " ." + copyClassName).eq(copyIndex).clone(true);
    node.attr('id',id);
    node.attr('data-index',index);

    return node;
}

/**
 * 复制元素 DragImageBlock 特用
 *
 * @param copyIndex 被复制的元素索引值
 * @param id 新元素id
 * @param index 新元素索引值
 * @param copyClassName 被复制的元素类名
 * @param parentId 被复制的元素父级id
 * @returns {null|*|jQuery}
 */
function copyDivByParentIdDragImageBlock(copyIndex,id,index,copyClassName,parentId,typeIndex){
    if ($("#" + parentId + " ." + copyClassName).eq(copyIndex) != null && $("."+copyClassName).eq(copyIndex).length <= 0){
        return null;
    }

    var node = $("#" + parentId + " ." + copyClassName).eq(copyIndex).clone(true);
    node.attr('id',id);
    node.attr('data-index',index);
    node.children('.productImgDiv').children('.dragProductImage').attr('id',"dragProductImage-"+typeIndex+'-'+ index);
    node.children('.productTitleDiv').children('.heading').attr('id',"dragProductHeading-"+typeIndex+'-'+ index);
    node.children('.productPriceDiv').children('.preferentialPrice').children().attr('id',"preferentialPrice-"+typeIndex+'-'+ index);
    node.children('.productPriceDiv').children('.originalPrice').children().attr('id',"originalPrice-"+typeIndex+'-'+ index);
    node.children('.productVariantsDiv').children('.productVariants').attr('id','productVariants-'+typeIndex+'-'+index);
    node.children('.productVariantsDiv').children('.productVariants').attr('data-type',typeIndex);
    node.children('.productVariantsDiv').children('.productVariants').attr('data-index',index);
    node.children('.productAddCartDiv').children('.dragImageAddCartFrom').children('.fromVariantId').attr('id','dragImageVariantId-'+typeIndex+'-'+index);

    return node;
}


/**
 * 粘贴到指定元素指定方向
 * @param direction
 * @param affixClassName
 */
function appendDivByClassName(direction,affixClassName,node){

    if (direction == "before"){
        $("."+affixClassName).append(node);
    }else {
        $("."+affixClassName).prepend(node);
    }
}

/**
 * 粘贴到指定元素指定方向
 * @param direction
 * @param affixId
 */
function appendDivById(direction,affixId,node){
    if (direction == "before"){
        $("#"+affixId).append(node);
    }else {
        $("#"+affixId).prepend(node);
    }
}

/**
 * 休眠
 * @param ms
 * @returns {Promise<unknown>}
 */
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * jquery设置cookie
 * @param key
 * @param value
 * @param expires
 */
function jqSetCookie(key,value,expires){
    $.cookie(key,value,{expires:expires,path: '/'})
}

/**
 * 获取 cookie 的值
 * @param name
 * @returns {string}
 */
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

/**
 * 删除cookie
 * @param name
 */
function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

/**
 * 去除过期的商品数据
 * @param data 数组
 */
function removeExpiredProductData(data){
    var newData = [];
    for (var i = 0; i < data.length; i++) {
        var differValue = calculateIntervalTime(new Date().getTime(),data[i].saveDate);
        if (differValue <= 24){
            newData.push(data[i]);
        }
    }


    return newData;
}

/**
 * @param currentTime 当前时间时间戳
 * @param appointTime 旧时间时间戳
 * @type {Date}
 */
function  calculateIntervalTime(currentTime,appointTime)
{

    //返回小时
    var differValue = (currentTime -appointTime);
    var h = differValue / (60 * 60 * 1000)
    return h;
}

/**
 * 根据产品句柄获取产品信息
 * @param handle
 */
function getProductInfo(handle){
    var result;
    $.ajax({
        type: 'get',
        async:false,
        url:  '/products/'+handle+'.js',
        success:function (d){
            result=JSON.parse(d);
        }
    });
    return result;
}

//

/**
 * graphQL请求
 */
async function graphQLUtils(data){

     const STOREFRONT_ACCESS_TOKEN =  'ea2204ea154019703128af6f4b4f7188'
    const GRAPHQL_URL = '/api/2024-07/graphql.json'
    $.ajax({
        url: GRAPHQL_URL,
        type: "POST",
        async:false,
        contentType: 'application/graphql',
        headers: {
            "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN
        },
        data: data,
        dataType: 'json', // 预期服务器返回的数据类型
        success: function(result) {
            console.log('resultttt',result)
            return result;
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.error('请求失败: ' + textStatus, errorThrown);
        }
    });
}

/**
 * 收缩展开
 * @param targetId 目标id
 * @param arrowId 箭头id
 */
function slideUpDown(targetId,arrowId){


    // 箭头旋转 目标块收缩展开
    if ( $("#"+arrowId).css('transform') === 'matrix(1, 0, 0, 1, 0, 0)' || $("#"+arrowId).css('transform') === null){
        $("#"+arrowId).css('transform','rotate(180deg)');
        $('#'+targetId).slideUp(300);
    }else {
        $("#"+arrowId).css('transform','rotate(0deg)');
        $('#'+targetId).slideDown(300);
    }


}

/**
 * 播放或暂停 视频(切换)
 * @param id 视频id
 * @param buttonId 按钮id
 */
function videoPlayOrPause(id,buttonId){
    var video = document.getElementById(id);
    var videoButton = $("#"+buttonId);

    if (video.paused){
        // 暂停状态
        videoButton.fadeOut();
        video.play();
        video.controls = true;
    }else {
        // 播放状态
        videoButton.fadeIn();
        video.pause();
        video.controls = false;
    }
}

/**
 * 暂停视频
 * @param className
 * @param buttonId
 */
function videoListPause(className,buttonId){
    var videos = document.querySelectorAll("."+className);
    var videoButton = $("#"+buttonId);
    videos.forEach(function(video) {
        if (video instanceof HTMLMediaElement) {
            video.pause();
            videoButton.fadeIn();
        }
    });
}

/**
 * 设置swiper下的div的高相同
 * @param className
 */
function setSwiperContentHeight(className){

    const contentDivs = document.querySelectorAll('.'+className);

    contentDivs.forEach(div => {
        div.style.height = 'auto';
    })
    // 找到最大高度
    let list = []
    contentDivs.forEach(div => {
        const height = div.offsetHeight;
        list.push(parseInt(height))
    })

    var maxHeight = Math.max(...list)

    // console.log(maxHeight)

    // 设置所有 content div 的高度为最大高度
    contentDivs.forEach(div => {
        div.style.height = maxHeight + 'px';
    });
}

/**
 * 排序 所有产品页
 * @param sortFlag
 * @param className
 */
function sortByPrice(sortFlag,className){
    let productDiv = $("."+className);
    // 选择所有的产品 DIV
    let productDivList =productDiv.get(); // 转换为普通数组

    // 对数组进行排序
    productDivList.sort((a, b) => {
        // 获取 data-price 属性值并转换为数字
        let priceA = parseFloat($(a).attr('data-price'));
        let priceB = parseFloat($(b).attr('data-price'));
        let creatDateA = new Date($(a).attr('data-created'));
        let creatDateB = new Date($(b).attr('data-created'));
        if (sortFlag === 'ascByPrice'){
            return priceA - priceB; // 按价格升序排序
        }else if (sortFlag === 'descByPrice'){
            return priceB - priceA; // 按价格降序排序
        }else if (sortFlag === 'descByCreatTime'){
            // 按创建时间降序排序
            if (creatDateB >= creatDateA){
                return 1;
            }else {
                return -1;
            }
        }

    });

    // 将排序后的元素重新添加到 DOM
    let container = productDiv.parent(); // 父级元素
    productDivList.forEach(item => {
        container.append(item); // 重新添加到父元素
    });
}

/**
 * 显隐产品块
 * @param radioName
 * @param targetClassName
 */
function filterChangeCenter(radioName,targetClassName){
    // 产品系列筛选
    let allProductBlockList = $("."+targetClassName).toArray();
    let collectionType = $('input[name="'+radioName+'"]:checked').val()?$('input[name="'+radioName+'"]:checked').val():'all';
    let showBlockList = allProductBlockList.filter(function (e){
        if (collectionType !== 'all'){
            return $(e).attr('data-collection') === collectionType;
        }else{
            return true;
        }
    })
    // 显隐
    $("."+targetClassName).css('display','none');
    showBlockList.forEach(function(item, index) {
        $(item).css('display','flex');
    });
}

/**
 * 文件下载
 * @param pdfUrl
 */
function downloadPDF(pdfUrl) {
    fetch(pdfUrl)
        .then(response => response.blob())
        .then(blob => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            console.error('PDF下载失败:', error);
        });
}

/**
 * 为视频添加加载动画
 * @param videoParentId 视频标签的父级class
 */
async function videoLoadingAnimation(videoParentClassName){

    $("."+videoParentClassName).each(function (){
        let self =$(this);
        let videoLength = self.find('video').length;

        const video = self.find('video');
        const loader = self.find('.video-loader');
        const videoPreview = loader.find('.video-preview');

        $(video).on('canplaythrough', function() {
            loader.css('display','none');
            video.css('display','flex');
        });

        video.on('waiting', function() {
            loader.css('display','flex');
        });

        video.on('playing', function() {
            loader.css('display','none') ;
        });
    })

}



// 产品分页过滤 -> 点击展开事件
function dropDownClick(level,categoryLevel1,categoryLevel2){

    let id = "#" + level + "_" + categoryLevel1;
    let arrowId = '#'+level+"_arrow_"+categoryLevel1;
    let labelId = '#'+level+"_label_"+categoryLevel1;

    if (categoryLevel2 !== null && categoryLevel2 !== undefined){
        id = "#" + level + "_" + categoryLevel1 + "_" + categoryLevel2;
        labelId = '#'+level+"_label_"+ categoryLevel1 + "_"+categoryLevel2;
    }

    if ($(id).css('display') === 'none'){
        $(id).slideDown();
        $(arrowId).css('transform','rotate(0deg)');
        $(labelId).attr('style','color:#0068b7;');
    }else {
        $(id).slideUp();
        $(arrowId).css('transform','rotate(180deg)');
        $(labelId).attr('style','color:#303030;');
    }

}

// 产品分页过滤 -> 产品最末级点击
function productListShowClick(e,clickTarget,tag){

    e.stopPropagation();

    $.ajax({
        type:"get",
        url:"/search?view=json_result&type=product&page=1&unavailable_products=hide&q=tag:"+encodeURIComponent(tag),
        success: function (res) {
            setProductCard(res);
        },
    })

    // 末级颜色变更
    $(".level_last").removeClass("activeLevelTab");
    $(clickTarget).addClass("activeLevelTab");

    // $('html, body').animate({
    //     scrollTop: $('#productPageFilter').offset().top
    // }, 500); // 1000 毫秒为动画持续时间
}

// 产品分页过滤 -> 箭头点击
function paginationArrowClick(e,link){
    $.ajax({
        type:"get",
        url:link,
        success: function (res) {
            setProductCard(res);
        },
    })
}

// 产品分页过滤 -> 搜索栏搜索
function productSearchByType(isMobile){
    let typeName
    if(isMobile){
         typeName = $("#productPageSearchInput_mobile").val();
    }else{
         typeName = $("#productPageSearchInput").val();
    }
    let searchConditions = "product_type:*";
    console.log(typeName,'typeName');
    if (typeName != null && typeName != ''){
        searchConditions =  "product_type:*"+typeName+'*';
    }
    console.log(searchConditions,'searchConditions');
    $.ajax({
        type:"get",
        url:"/search?view=json_result&type=product&page=1&unavailable_products=hide&q="+searchConditions,
        success: function (res) {
            setProductCard(res);
        },
    })
}

// 产品分页过滤 -> 搜索框输入回车监听
function handleKeyPress(event,isMobile) {
    if (event.key === 'Enter') {
        // 在这里执行您想要的操作
        productSearchByType(isMobile);
    }
}

// 产品分页过滤 -> 设置产品卡片与其他相关设置
function setProductCard(res){
    let data =  JSON.parse(res.trim());
    let count = data.results_count;
    let html = '';
    // 总数
    $(".resultCountTitle").text(count + ' Products Matches');

    // 产品卡片
    let productList = data.result;
    if (!Array.isArray(productList)){
        html = html + getProductCardHtml(productList);
    }else {
        productList.forEach(product => {
            html = html + getProductCardHtml(product);
        });
    }

    $(".productResultList .productList").html(html);

    // 页码
    $(".paginationCount").text('/'+data.pageCount);
    //$("#paginationInput").val(data.current_page);
    $(".paginationInputDiv").text(data.current_page);

    // 箭头
    // 左箭头
    if (data.previous === null){
        $(".paginationLeft").attr('onclick','');
    }else {
        $(".paginationLeft").attr('onclick','paginationArrowClick(event,"'+data.previous.url+'")');
    }
    // 右箭头
    if (data.next === null){
        $(".paginationRight").attr('onclick','');
    }else {
        $(".paginationRight").attr('onclick','paginationArrowClick(event,"'+data.next.url+'")');
    }
}

// 产品分页过滤 -> 获取产品卡片html代码
function getProductCardHtml(product){
    if (product != null && product != ''){
        return '<a class="productCard" href="/products/'+product.handle+'">' +
            '<div class="productImgDiv">' +
            '<img src="'+product.featured_image+'">' +
            '</div>' +
            '<div class="productTextDiv">' +
            '<div class="productType">'+product.type+'</div>' +
            '<div class="productDec">'+product.description+'</div>' +
            ' <div class="productLink">Learn More >></div>' +
            '</div>' +
            '</a>';
    }
    return '';
}

/**
 * 阻止视频点击默认事件
 * @param e
 */
function videoPreventClick(e){
    e.preventDefault();
}

/**
 * 跳转页面并设置cookie值
 * @param url
 * @param cookieKey
 * @param cookieValue
 */
function hrefAndSetCookie(url,cookieKey,cookieValue) {
    jqSetCookie(cookieKey,cookieValue,24 * 60);
    window.location = url;
}

/**
 * 跳转页面并设置cookie值-移动版
 * @param url
 * @param cookieKey
 * @param cookieValue
 */
// function hrefAndSetCookieMobile(cookieKey,cookieValue) {
//     console.log(cookieValue,'cookieValue');
//     jqSetCookie(cookieKey,cookieValue,24 * 60);
// }